import { Avatar } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { EventRegistration } from '../../../../../interfaces/interfaces';
import { setProfileInfoUser } from '../../../../../reduxToolkit/slices/commonSlice';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { createDisplayLink } from '../../../../../services/helper';
import { getPublicRegistration } from '../../../../../services/services';
import VyModal from '../../../../common/VyModal';
import { ProfileRegistrationInfo } from './ProfileRegistrationInfo';
import { getContrastColor } from '../../../../../utils/functions';

const ProfileInfoModal = () => {
  const event = useSelector((state) => state.common.event);
  const profileInfoUser = useSelector((state) => state.common.profileInfoUser);
  const isMobilePreview = useSelector((state) => state.common.isMobilePreview);
  const { t } = useTranslation(['event', 'toasts']);
  const dispatch = useDispatch();

  const [color, setColor] = useState([216, 97, 34]);
  const eventColor = useSelector(({ common }) => common.event?.template.mainColor);

  const [registration, setRegistraion] = useState<EventRegistration | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const notOrgMember = registration?.user && event && registration?.user.organization?._id !== event.organization?._id;

  useEffect(() => {
    if (!profileInfoUser) return;
    fetchAttendeeRegistration(profileInfoUser);
  }, [profileInfoUser]);

  const fetchAttendeeRegistration = async (userid: string) => {
    if (!event) return;
    setIsLoading(true);
    const { data: _registration } = await getPublicRegistration(userid, event._id);
    setRegistraion(_registration);
    setIsLoading(false);
  };

  const handleClose = () => {
    dispatch(setProfileInfoUser(undefined));
  };

  return (
    <VyModal open={!!profileInfoUser} onClose={handleClose} maxWidth="70cqw" disablePortal={isMobilePreview} hasDefaultPadding={false}>
      {() => (
        <div className="relative flex flex-col items-center justify-center w-full h-full max-w-xl p-6 overflow-y-auto rounded-xl templateBorder">
          {registration?.user && !isLoading && (
            <div className="flex flex-col gap-4">
              <div className="flex flex-col items-center justify-center">
                <Avatar
                  className={`large-avatar text-2xl font-bold`}
                  src={registration.user?.avatar ? createDisplayLink(registration.user.avatar) : undefined}
                  style={{ width: '150px', height: '150px', backgroundColor: getContrastColor(eventColor) }}>
                  {registration.user.name.substring(0, 1)}
                </Avatar>
                {/* {(registration.user?.profileStatus?.emoji || registration.user?.profileStatus?.text) && (
                      <p className="px-2 py-1 border border-black rounded-full">
                        {registration.user?.profileStatus?.emoji ?? ''}&nbsp;&nbsp;&nbsp;&nbsp;{registration.user?.profileStatus?.text ?? ''}
                      </p>
                    )} */}
              </div>
              <div className="flex flex-col w-full gap-2">
                <b className="self-center text-xl">{registration.user.name}</b>
                {!!registration.registrationFields && <div>{notOrgMember && <ProfileRegistrationInfo registration={registration} />}</div>}
              </div>
            </div>
          )}

          {!registration?.user && !isLoading && (
            <div className="grid place-items-center h-60" style={{ width: '60cqw' }}>
              <b className="italic">{t('event:avatar-profile-no-data')}</b>
            </div>
          )}
          {isLoading && (
            <div className="flex flex-col w-full gap-4">
              <div className="flex flex-col items-center justify-center">
                <div className="bg-gray-200 animate-pulse w-[150px] h-[150px] rounded-full" />
              </div>
              <div className="flex flex-col w-full gap-2">
                <div className="self-center w-32 h-4 bg-gray-200 rounded-md animate-pulse" />
                <div className="self-center h-12 max-w-full bg-gray-200 rounded-md w-80 animate-pulse" />
              </div>
            </div>
          )}
        </div>
      )}
    </VyModal>
  );
};

export default ProfileInfoModal;
